var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.toOrderList}},[_c('img',{attrs:{"src":require("@assets/images/home/icon_orders.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }